import { BadgeCheck, ShieldCheck, Heart } from "lucide-react";

// Trust badge shown on verified Member profiles.
export default function VerifiedBadge({ size = "md", showLabel = false, className = "" }) {
  const dims = size === "sm" ? "w-4 h-4" : size === "lg" ? "w-6 h-6" : "w-5 h-5";
  if (showLabel) {
    return (
      <span
        data-testid="verified-badge"
        title="Verified by Haplap"
        className={`inline-flex items-center gap-1 text-xs font-semibold text-sage bg-sage/15 border border-sage/30 rounded-full px-2.5 py-1 ${className}`}>
        <BadgeCheck className="w-3.5 h-3.5" /> Verified
      </span>
    );
  }
  return (
    <span data-testid="verified-badge" title="Verified by Haplap" className={`inline-flex text-sage ${className}`}>
      <BadgeCheck className={dims} fill="currentColor" stroke="white" />
    </span>
  );
}

// Fully-verified "100% Trusted" badge — a higher tier earned after full document review.
export const TrustedBadge = ({ className = "" }) => (
  <span data-testid="trusted-badge" title="100% Trusted — fully verified by Haplap"
    className={`inline-flex items-center gap-1 text-xs font-semibold text-copper bg-copper/12 border border-copper/30 rounded-full px-2.5 py-1 ${className}`}>
    <ShieldCheck className="w-3.5 h-3.5" /> 100% Trusted
  </span>
);

// "Under Our Wing" badge — a trusted member whose identity we keep private.
export const UnderWingBadge = ({ className = "" }) => (
  <span data-testid="under-wing-badge" title="Under Our Wing — verified and kept private by Haplap"
    className={`inline-flex items-center gap-1 text-xs font-semibold text-penny bg-penny/15 border border-penny/30 rounded-full px-2.5 py-1 ${className}`}>
    <Heart className="w-3.5 h-3.5" fill="currentColor" /> Under Our Wing
  </span>
);
